<template>
  <RtTableTitle
    v-show="tabRange"
    :flipped="flipped"
    class="z-index_3"
  >
    <template #left>
      <div
        v-if="hasSimpleTitle"
        class="weight_700 clr-grey text-nowrap f-align-center line-height_1 text-normal"
        style="gap: 0.25rem"
      >
        <i
          v-if="player.is_hero"
          class="mdi mdi-crown"
        ></i>
        <span :class="{ opacity_0: !player.position }">
          {{ (player.position && $t(`players.${player.position}`)) || '-' }}
        </span>
      </div>
      <UnSwitcherNew
        v-else-if="hasPlayerDropdownOptions"
        :options="playerDropdownOptions"
        :tab="playerKey"
        :hasText="true"
        :isInside="false"
        :hasOpener="true"
        :asMenu="playerDropdownOptions.length > 1"
        :tstPrefix="tstPrefix"
        :style="switcherStyle"
        @click="$emit('select-player', $event)"
      >
        <template #selected="{ item }">
          <div
            class="text-nowrap f-align-center line-height_1"
            style="gap: 0.25rem"
          >
            {{ item.text }}
            <i
              v-if="item.icon"
              :class="item.icon"
              class="mdi"
            ></i>
          </div>
        </template>

        <template #default="{ item }">
          <div
            class="text-nowrap f-align-center line-height_1"
            style="gap: 0.25rem"
          >
            {{ item.text }}
            <i
              v-if="item.icon"
              :class="item.icon"
              class="mdi"
            ></i>
          </div>
        </template>
      </UnSwitcherNew>
      <UnSwitcherNew
        v-if="hasRangeContentSwitcher"
        :hasText="true"
        :isInside="true"
        :hasOpener="true"
        :tab="playerDetail?.range_content"
        :asMenu="l_tableSwitchAsMenu"
        :tstPrefix="rangeContentTstPrefix"
        :options="getPlayerRangeContentOptions(playerKey)"
        :style="switcherStyle"
        :hasNamedSelectedSlot="true"
        :hasNamedDefaultSlot="true"
        @click="$emit('select-range-content', $event)"
      />
    </template>
    <template #right>
      <RangeCopyBtn
        v-if="showRangeCopyBtn"
        :flipped="flipped"
        :range="range"
        :hasActions="hasActions"
        :showBetsIn="showBetsIn"
      />
    </template>
  </RtTableTitle>

  <div class="f-column flex-1 position-relative d-flex z-index_2">
    <MessagesRangeTable2
      :namespace="namespace"
      :canAISolve="canAISolve"
      :translatePath="tabRange ? 'switchers' : 'tabs'"
      :showEvIn="bettingInfo.showEvIn"
      class="twtbls_message-overlay"
      :style="messageStyle"
      :options="getPlayerRangeContentOptions(playerKey)"
      :isHero="playerDetail?.is_hero"
      :showProp="showProp || playerDetail?.range_content"
      :showFlopContent="showFlopContent"
      :hasShortcutBtn="hasShortcutBtn"
    />
    <StudyRangeTable2
      :playerKey="playerKey"
      :playersDetail="playersDetail"
      :data-tst="dataTst"
      :canBeLocked="canBeLocked"
      :tableGroups="tableGroups"
      :setHoveredComboForLeftPlayerOnly="!tabRange"
      :viewProps="viewProps"
      :filterCombos="filterCombos"
      :filterEvCompare="filterEvCompare"
      :evProps="evProps"
      :grouping="grouping"
      :bettingInfo="bettingInfo"
      :useHex="useHex"
      :showBetsIn="showBetsIn"
      :tableMouseover="tableMouseover"
      :street="street"
      :rangeKey="viewProps.rangeKey"
      :showProp="showProp || playerDetail?.range_content"
      :asEmpty="asEmpty"
      :noValue="noValue"
      :valueProp="valueProp"
      :isCentered="tabRange && (!rangesMaximized || max1280)"
      @combo:click="$emit('combo-click', $event)"
      @touchend="$emit('touch-end', $event)"
    />
  </div>
</template>

<script>
import UnSwitcherNew from '@/components/Switchers/UnSwitcher_new'
import RangeCopyBtn from '@/components/RangeCopyBtn/RangeCopyBtn'
import RtTableTitle from '@/components/RangeTables/RtTableTitle'
import StudyRangeTable2 from '@/components/Study/StudyRangeTable2'
import MessagesRangeTable2 from '@/components/Poker/Overlays/Messages/MessagesRangeTable2'

export default {
  name: 'RtTable',
  components: {
    UnSwitcherNew,
    RangeCopyBtn,
    RtTableTitle,
    MessagesRangeTable2,
    StudyRangeTable2,
  },
  props: {
    namespace: { required: true, type: String },
    canAISolve: { required: true, type: Boolean },
    playerKey: String,
    flipped: Boolean,
    hasSimpleTitle: Boolean,
    hasPlayerDropdownOptions: { type: Boolean, default: true },
    playerDropdownOptions: Array,
    hasRangeContentSwitcher: { type: Boolean, default: true },
    playersDetail: { default: () => [] },
    player: Object,
    l_tableSwitchAsMenu: Boolean,
    tstPrefix: String,
    rangeContentTstPrefix: String,
    switcherStyle: String,
    showRangeCopyBtn: Boolean,
    range: Object,
    hasActions: Boolean,
    showBetsIn: String,
    tabRange: Boolean,
    bettingInfo: Object,
    showFlopContent: Boolean,
    hasShortcutBtn: Boolean,
    dataTst: String,
    canBeLocked: Boolean,
    tableGroups: Array,
    viewProps: Object,
    filterCombos: Object,
    filterEvCompare: Object,
    evProps: Object,
    grouping: String,
    useHex: Boolean,
    tableMouseover: Boolean,
    street: String,
    rangesMaximized: Boolean,
    max1280: Boolean,
    asEmpty: Boolean,
    noValue: Boolean,
    valueProp: String,
    showProp: String,
  },
  emits: ['select-player', 'select-range-content', 'combo-click', 'touch-end'],
  methods: {
    getPlayerRangeContentOptions() {
      const options = [
        { payload: 'ev' },
        { payload: 'eq' },
        { payload: 'eqr' },
        { payload: 'range' },
      ]

      if (this.playerDetail?.is_hero) {
        options.unshift({ payload: 'strategy' })
      }

      return options
    },
  },
  computed: {
    playerDetail() {
      return this.playersDetail[this.playerKey]
    },
    messageStyle() {
      return `
        --back-from: var(--clr-black-0);
        --clr-message-back: transparent;
        --clr-message-back: var(--clr-back);
        --radius: 4px;
        ${this.tabRange ? '--size-title: 1rem; --btn-font-size: 0.8rem;' : ''}
      `
    },
  },
}
</script>
